import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import {
  addClientData,
  removeClientData,
} from "../../../../../data/redux/slice/clientOnboardDataSlice";
import { modalNavigation } from "../../../../../data/redux/slice/modalNavigationSlice";

import CustomStepperNew from "../../../../components/ui_comps/CustomStepperNew";
import BankDetailsNew from "./BankDetailsNew";
import BasicDetailsNew from "./BasicDetailsNew";
import BusineessDetailsNew from "./BusinessDetailsNew";
import DocumentDetailsNew from "./DocumentDetailsNew";
import KycDetailsNew from "./KycDetailsNew";
import MainBasicDetails from "./MainBasicDetails";
import ServiceRate from "./ServiceRate";
import Limits from "./Limits";
import VAN from "./VAN";

function ClientOnboardNew({ onSuccess, onClose }) {
  const [currentStep, setCurrentStep] = useState(1);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const currentModalStep = useSelector(
    (state) => state.modalNavSlice.clientStep
  );
  const clientData = useSelector((state) => state.onboardClientSlice);

  const tabs = [
    {
      name: "Service",
      key: 1,
    },

    {
      name: "Basic Information",
      key: 2,
    },
    {
      name: "Business Details",
      key: 3,
    },
    {
      name: "Bank Details",
      key: 4,
    },
    {
      name: "Documents",
      key: 5,
    },
    {
      name: "VKYC",
      key: 6,
    },
    {
      name: "Service Rate",
      key: 7,
    },
    {
      name: "Limits",
      key: 8,
    },
    {
      name: "VAN",
      key: 9,
    },
  ];

  const onClickCancel = () => {
    dispatch(modalNavigation(1));
    dispatch(removeClientData());
    navigate("/dashboard");
  };

  useEffect(() => {
    setCurrentStep(currentModalStep);
  }, [currentModalStep]);

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        marginTop: "40px",
        padding: "0px 30px",
      }}
    >
      <div style={styles.title}>Onboarding a Client</div>

      <CustomStepperNew
        totalStep={7}
        currentStep={currentStep}
        tabs={tabs}
      // style={{ position: "relative" }}
      />

      <div
        style={{
          width: "100%",
          height: "100%",
          // marginTop: "5%",
          textAlign: "start",
          // padding: "0px 15px",
          position: "relative",
        }}
      >
        {currentStep === 1 ? (
          <MainBasicDetails
            onClickCancel={onClickCancel}
            onClickNext={(data) => {
              setCurrentStep(2);
              dispatch(modalNavigation(2));
              dispatch(
                addClientData({
                  ...data,
                })
              );
            }}
            reduxData={clientData}
          />
        ) : currentStep === 2 ? (
          <BasicDetailsNew
            onClickNext={(data) => {
              setCurrentStep(3);
              dispatch(modalNavigation(3));
              dispatch(
                addClientData({
                  ...data,
                })
              );
            }}
            onClickPrevious={() => {
              setCurrentStep(1);
            }}
            onClickCancel={onClickCancel}
            reduxData={clientData}
          />
        ) : currentStep === 3 ? (
          <BusineessDetailsNew
            onClickBack={onClose}
            onClickNext={(data) => {
              setCurrentStep(4);
              dispatch(modalNavigation(4));
              dispatch(addClientData({ ...data }));
            }}
            reduxData={clientData}
            onClickPrevious={() => {
              setCurrentStep(2);
            }}
            onClickCancel={onClickCancel}
          />
        ) : currentStep === 4 ? (
          <BankDetailsNew
            onClickPrevious={() => {
              setCurrentStep(3);
            }}
            onClickCancel={onClickCancel}
            reduxData={clientData}
            onClickNext={(data) => {
              setCurrentStep(5);
              dispatch(modalNavigation(5));
              dispatch(addClientData({ ...data }));
            }}
          />
        ) : currentStep === 5 ? (
          <DocumentDetailsNew
            onClickBack={onClose}
            onClickNext={(data) => {
              setCurrentStep(6);
              dispatch(modalNavigation(6));
              dispatch(addClientData({ ...data }));
            }}
            reduxData={clientData}
            onClickPrevious={() => {
              setCurrentStep(4);
            }}
            onClickCancel={onClickCancel}
          />
        ) : currentStep === 6 ? (
          <KycDetailsNew
            reduxData={clientData}
            onClickNext={(data) => {
              setCurrentStep(7);
              dispatch(modalNavigation(7));
              dispatch(addClientData({ ...data }));
            }}
            onClickBack={onClose}
            onClickPrevious={() => {
              setCurrentStep(5);
            }}
            onClickCancel={onClickCancel}
          />
        ) : currentStep === 7 ? (
          <ServiceRate
            reduxData={clientData}
            onClickNext={(data) => {
              setCurrentStep(8);
              dispatch(modalNavigation(8));
              dispatch(addClientData({ ...data }));
            }}
            onClickBack={onClose}
            onClickPrevious={() => {
              setCurrentStep(6);
            }}
            onClickCancel={onClickCancel}
          />
        ) : currentStep === 8 ? (
          <Limits
            onClickPrevious={() => {
              setCurrentStep(7);
            }}
            reduxData={clientData}
            onClickNext={(data) => {
              setCurrentStep(9);
              dispatch(modalNavigation(9));
              dispatch(addClientData({ ...data }));
            }}
            onClickCancel={onClickCancel}
          // onSuccess={() => {
          //   dispatch(modalNavigation(1));
          //   dispatch(removeClientData());
          //   navigate("/dashboard");
          // }}
          />
        ) : currentStep === 9 ? (
          <VAN
            onClickPrevious={() => {
              setCurrentStep(8);
            }}
            reduxData={clientData}
            onClickNext={(data) => {
              // dispatch(modalNavigation());
              dispatch(addClientData({ ...data }));
            }}
            onClickCancel={onClickCancel}
            onSuccess={() => {
              dispatch(modalNavigation(1));
              dispatch(removeClientData());
              navigate("/dashboard");
            }}
          />
        ) : (
          <></>
        )}
      </div>
    </div>
  );
}

export default ClientOnboardNew;

const styles = {
  title: {
    fontSize: "24px",
    fontWeight: "400",
    color: " #000000",

    minHeight: "80px",

    position: "relative",
    textAlign: "center",
    marginLeft: "-10%",
    // marginTop: "10px",
  },
};
